export const updateInnerHTMLContent = (params: { tabContent: HTMLElement; html: string }) => {
  const { tabContent, html } = params;

  const parser = new DOMParser();
  const doc = parser.parseFromString(html, 'text/html');
  const parsedContent = doc.body.children;

  while (tabContent?.firstChild) {
    tabContent.removeChild(tabContent.firstChild);
  }

  Array.from(parsedContent).forEach((node) => {
    tabContent.appendChild(node);
  });
};
